import { useRef } from 'react';

import { getRouteApi } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { BsChatDots } from 'react-icons/bs';

import Notes from '../Notes';
import { useGetConsorsNotesByLeadId } from '../Notes/hooks/useGetConsorsNotesByLeadId';
import DialogBox from '~/components/DialogBox';
import { LEAD_DETAILS_OVERLAYS } from '~/features/leadDetails/constants/overlays';
import { useLeadDetailsModalNavigation } from '~/features/leadDetails/hooks/useLeadDetailsModalNavigation';
import { cn } from '~/utils/cnTailwind';

type ButtonProps = {
    withLabel?: boolean;
};

export const ConsorsNotesButton = ({ withLabel = false }: ButtonProps) => {
    const { useParams } = getRouteApi('/_app/leads_/details/$leadId');
    const { leadId } = useParams();
    const { data } = useGetConsorsNotesByLeadId(leadId);
    const { hasNewConsorsNotes } = data ?? {};
    const { t } = useTranslation();
    const { openModal } = useLeadDetailsModalNavigation();

    return (
        <button
            type="button"
            onClick={() => openModal(LEAD_DETAILS_OVERLAYS.CONSORS_NOTES)}
            className={cn('w-full py-1.5 px-3 flex items-center gap-5 ', hasNewConsorsNotes && 'bg-red-new')}
        >
            {hasNewConsorsNotes ? <BsChatDots color="red" size={16} /> : <BsChatDots color="grey" size={16} />}
            {withLabel && <span className="text-xs">{t('OFFER_MANAGEMENT.ICONS_TOOLTIP.BANK_CHAT')}</span>}
        </button>
    );
};

type DialogProps = {
    isOpen: boolean;
    onClose: () => void;
};

export const ConsorsNotesDialog = ({ isOpen, onClose }: DialogProps) => {
    const initialFocusRef = useRef<HTMLDivElement>(null);

    return (
        <DialogBox
            initialFocusRef={initialFocusRef}
            open={isOpen}
            onClose={onClose}
            panelClassName="max-w-[450px] bg-grey-light"
            title={null}
        >
            <Notes />
        </DialogBox>
    );
};
